import React, { useState } from "react";
import { faqRepo } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { Card, EmptyState, useAsync } from "../../components/ui";

export default function Help() {
  const { orgId } = useApp();
  const { tx } = useI18n();
  const { data: faqs } = useAsync(() => faqRepo.all(orgId), [orgId], []);
  const [openId, setOpenId] = useState(null);

  if (!faqs?.length) return <EmptyState text={tx("ยังไม่มีคำถามที่พบบ่อย", "No FAQs yet")} />;

  return (
    <Card title={tx("คำถามที่พบบ่อย", "Frequently asked questions")}>
      {faqs.map((faq) => (
        <div key={faq.id} style={{ borderBottom: "1px solid var(--c-slate-100)", padding: "10px 0" }}>
          <button
            type="button"
            onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
            style={{ width: "100%", textAlign: "left", border: "none", background: "none", cursor: "pointer", display: "flex", justifyContent: "space-between", fontWeight: 600, fontSize: 14 }}
          >
            {faq.question}
            <span>{openId === faq.id ? "−" : "+"}</span>
          </button>
          {openId === faq.id ? <div className="u-fs-13 u-muted u-mt-8">{faq.answer}</div> : null}
        </div>
      ))}
    </Card>
  );
}
